/*
 * Copyright (c) 2023 Irian Software Development SRL. All Rights Reserved.
 * This software is the proprietary information of Irian Software Development SRL.
 * Use is subject to license and non-disclosure terms
 */

import { ErrorHandler, ModuleWithProviders, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ExceptionService } from './service/exception.service';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { HttpErrorInterceptor } from './error-handler/http-error-interceptor';
import { HttpErrorResponseWrapper } from './error-handler/error-wrappers/http-error-response.wrapper';
import { BaseErrorWrapper } from './error-handler/error-wrappers/base-error.wrapper';
import { ErrorWrapper } from './error-handler/error-wrappers/error.wrapper';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import * as langs from './i18n/i18n';
import { ApplicationErrorHandler } from './error-handler/application-error.handler';
import { EnvironmentModule } from '@irian-ro/util-environment';

@NgModule({
  imports: [CommonModule, TranslateModule, EnvironmentModule],
  declarations: [],
  providers: [],
})
export class ExceptionModule {
  constructor(private translateService: TranslateService) {
    Object.keys(langs).map((lang) => {
      translateService.setTranslation(lang, langs[lang], true);
    });
  }

  public static forRoot(config: {
    applicationErrorHandler?: any;
    httpErrorInterceptor?: any;
  }): ModuleWithProviders<ExceptionModule> {
    return {
      ngModule: ExceptionModule,
      providers: [
        ExceptionService,
        { provide: ErrorWrapper, useClass: HttpErrorResponseWrapper, multi: true },
        { provide: ErrorWrapper, useClass: BaseErrorWrapper, multi: true },
        {
          provide: ErrorHandler,
          useClass: config.applicationErrorHandler ? config.applicationErrorHandler : ApplicationErrorHandler,
        },
        {
          provide: HTTP_INTERCEPTORS,
          useClass: config.httpErrorInterceptor ? config.httpErrorInterceptor : HttpErrorInterceptor,
          multi: true,
        }
      ],
    };
  }
}
